module.exports = __webpack_public_path__ + "static/media/productTypeLight.02812eba.svg";